export const FormRadio: React.FC<
  {
    text: string;
  } & React.InputHTMLAttributes<HTMLInputElement>
> = ({ text, ...attr }) => (
  <label className="tw-grid tw-grid-cols-[auto,1fr] tw-items-center tw-gap-[0.5rem]">
    <div className="tw-relative tw-h-[1.3rem] tw-w-[1.3rem]">
      <input type="radio" className="tw-peer tw-opacity-0" {...attr} />
      <div className="tw-absolute tw-inset-0 tw-rounded-[50%] tw-border-[2px] tw-border-main-60 peer-checked:tw-bg-main-100" />
    </div>
    <div className="tw-text-base1 tw-leading-[1.4] tw-text-main-100">
      {text}
    </div>
  </label>
);
